/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SaturationIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Saturation',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m17.45117,13.3125c-.42285-.41016-.95898-.50391-1.37305-.57617-.33594-.05762-.37012-.08984-.5166-.22656-.08594-.08008-.1875-.20801-.1875-.36426,0-.15527.10156-.2832.1875-.3623l1.2041-1.11914c1.04785-.9707,1.625-2.27051,1.625-3.66016s-.57715-2.68848-1.62598-3.65918c-1.4502-1.33691-3.43652-2.07324-5.59375-2.07324-2.48828,0-4.97852.98535-6.83008,2.70312-1.76172,1.63086-2.73145,3.81348-2.73145,6.14453s.96973,4.51367,2.73145,6.14453c1.72754,1.59766,4.06738,2.48926,6.66211,2.50781,2.46094,0,4.80566-.86914,6.43066-2.38281.40234-.37109.62793-.90039.63672-1.48926.00781-.60742-.22266-1.2002-.61816-1.58594l-.00098-.00098Zm-1.03992,1.97852c-1.3512,1.25879-3.32239,1.98047-5.39758,1.98047-.26758-.00195-.53223-.01514-.79346-.03906-.23657-.02124-.46912-.05444-.69958-.09302-.02112-.00366-.04285-.00488-.06384-.00854-1.57654-.27515-2.99622-.94995-4.09692-1.96777-1.45129-1.34375-2.25049-3.13477-2.25049-5.04395s.79919-3.7002,2.25171-5.04492c1.17358-1.08911,2.64648-1.83057,4.19458-2.13965.00122-.00049.0022-.00073.00342-.00098.24072-.04785.48352-.08301.72705-.10962.02637-.00293.05249-.00903.07886-.01147.26794-.02686.53687-.04102.80591-.04102,1.3717,0,2.64624.36108,3.69714,1.01758.31213.19507.60974.40942.87781.65625.73816.68359,1.14478,1.5918,1.14478,2.55859,0,.83496-.31885,1.61743-.87793,2.25928-.08838.10156-.16724.20874-.26819.30225l-1.19885,1.11426c-.43311.39868-.67163.91919-.67163,1.46582,0,.34473.10474.67578.28394.97656.10303.17334.22412.33887.38074.48438.18445.17236.35339.29395.5426.38721.20532.10107.43481.16797.73889.22021.23206.04053.495.08643.58459.17334.03003.0293.05762.08594.08447.14111.0459.09424.08301.2085.08118.34863-.00183.12402-.03003.29492-.15918.41406Z"
      fill="currentColor"
    />
    <path
      d="m11.1709,4.27148c-1.09204,0-2.18567.27319-3.1709.7749v10.05322c.90771.41602,1.92749.66406,3.02441.67188.33081,0,.6554-.0293.97559-.07202V4.33936c-.271-.03662-.5448-.06787-.8291-.06787Z"
      fill="currentColor"
      opacity=".35"
    />
    <path
      d="m8,5.04639c-.58557.2981-1.13293.67676-1.61853,1.1272-1.14319,1.05859-1.77209,2.45923-1.77209,3.94556s.62842,2.88672,1.76953,3.94336c.46704.43188,1.02441.76392,1.62109,1.03711V5.04639Z"
      fill="currentColor"
    />
  </svg>`;
};
